<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("edit") }} {{ $t("globalloyaltysettings") }}
      </div>
      <router-link class="btn-blue" to="global-loyalty-settings"
        >{{ $t("globalloyaltysettings") }} {{ $tc("list") }}</router-link
      >
    </div>

    <div class="white-wrapper" style="zoom: 0.95">
      <div class="new-border back rounded-10 pt-2 px-3 pb-0 mb-2 back">
        <div class="row">
          <div class="col-12 mt-2 ml-0 pl-0 d-flex">
            <div class="col-lg-4 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <input
                  v-model="ls_name"
                  v-validate="'required'"
                  placeholder="."
                  type="text"
                  name="loyaltysettingname"
                  id="loyaltysettingname"
                  disabled
                />
                <label
                  >{{ $t("global") }} {{ $t("loyaltysettings") }}
                  {{ $t("name") }}</label
                >
              </div>
              <p
                v-if="submitted && errors.has('loyaltysettingname')"
                class="error_message"
              >
                <span>{{ errors.first("loyaltysettingname") }}</span>
              </p>
            </div>

            <div class="col-lg-3 col-xl-2 mb-3">
              <div class="input-material">
                <input
                  class="text-right"
                  v-model="lnitial_load"
                  v-validate="'required|numeric'"
                  type="number"
                  name="initialload"
                  id="initialload"
                />
                <label :for="'initialload'">{{ $t("initialamount") }}</label>
              </div>
              <p
                v-if="submitted && errors.has('initialload')"
                class="error_message"
              >
                <span>{{ errors.first("initialload") }}</span>
              </p>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="d-flex align-items-center">
                <div class="font-weight-bold">{{ $t("expiry") }}</div>
                <div class="dropdown-curve-container mx-2">
                  <!-- <label :class="expiry_rule.length > 0 ? 'shift-up' : ''">{{
                    $t("duration")
                  }}</label> -->
                  <b-dropdown
                    :text="expiry_rule"
                    variant="dropdown-curve"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(levels, levelIndex) in expiryArray"
                      :key="levelIndex"
                      @click="onSelectLevel(levels)"
                      >{{ levels["expiry_name"] }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <div class="input-material-sm">
                  <input
                    class="text-right"
                    v-model="expiry_value"
                    v-validate="'required|numeric'"
                    type="number"
                    name="expiryvalue"
                    id="expiryvalue"
                    v-if="selectedExpiry['show_input']"
                  />
                </div>
              </div>
              <p
                v-if="submitted && errors.has('expiryvalue')"
                class="error_message"
              >
                <span>{{ errors.first("expiryvalue") }}</span>
              </p>
              <p
                v-else-if="submitted && expiry_rule.length == 0"
                class="error_message"
              >
                <span
                  >{{ $t("please") }} {{ $t("select") }}
                  {{ $t("duration") }}</span
                >
              </p>
            </div>

            <div class="col-2 mb-3 d-flex align-items-center">
              <b-form-checkbox
                unchecked-value="N"
                v-model="visit_based_levels"
                value="Y"
                name="check-button"
                class="j-checkbox"
                @change="onChangeVistBasedLevels($event)"
              ></b-form-checkbox>
              <label class="pt-2">{{ "Visit Based" }}</label>
            </div>

            <div class="col-2 mb-3 d-flex align-items-center">
              <b-form-checkbox
                v-model="ls_is_active"
                name="check-button"
                class="j-checkbox pb-0 mr-1"
              ></b-form-checkbox>
              <label class="pt-2">{{ $t("active") }}</label>
            </div>
          </div>

          <div class="mb-2 px-3">
            <div class="levelText">Loyalty Levels</div>
          </div>
          <div
            class="col-12 px-0 d-flex"
            v-for="(item, index) in loyalty_levels"
            :key="index"
          >
            <div
              class="col-11 d-flex px-0 back_white mx-2 mb-2 pt-3"
              style="flex-wrap: wrap"
            >
              <div class="col-lg-4 col-xl-3 mb-3">
                <div class="input-material">
                  <input
                    v-model="item.ll_name"
                    :id="'llname' + index"
                    v-validate="'required'"
                    placeholder="."
                    type="text"
                    name="loyaltylevelname"
                  />
                  <label :for="'llname' + index"
                    >{{ $t("global") }} {{ $t("loyaltysettings") }}
                    {{ $t("level") }}</label
                  >
                </div>
                <p
                  v-if="submitted && errors.has('loyaltylevelname')"
                  class="error_message"
                >
                  <span>{{ errors.first("loyaltylevelname") }}</span>
                </p>
              </div>

              <div
                class="col-lg-4 col-xl-3 mb-3"
                v-if="visit_based_levels == 'Y'"
              >
                <div class="d-flex align-items-center">
                  <div class="input-material mr-3">
                    <input
                      class="text-right"
                      v-model="item.visits"
                      v-validate="'required|numeric'"
                      placeholder="."
                      type="number"
                      name="visits"
                      id="visits"
                    />
                    <label :for="'visits'"> Visits</label>
                  </div>
                  <div class="input-material">
                    <input
                      class="text-right"
                      v-model="item.visit_within_days"
                      v-validate="'required|numeric'"
                      placeholder="."
                      type="number"
                      name="visit_within_days"
                      id="visit_within_days"
                    />
                    <label :for="'visit_within_days'"> Within Days</label>
                  </div>
                </div>
                <p
                  v-if="submitted && errors.has('visits')"
                  class="error_message"
                >
                  <span>{{ errors.first("visits") }}</span>
                </p>
              </div>
              <div class="col-lg-3 col-xl-2 mb-3" v-else>
                <div class="input-material">
                  <input
                    class="text-right"
                    v-model="item.points_required"
                    v-validate="'required|numeric'"
                    placeholder="."
                    type="number"
                    name="pointrquired"
                    id="pointrquired"
                  />
                  <label :for="'pointrquired'">
                    {{ $t("pointsrequired") }}</label
                  >
                </div>
                <p
                  v-if="submitted && errors.has('pointrquired')"
                  class="error_message"
                >
                  <span>{{ errors.first("pointrquired") }}</span>
                </p>
              </div>

              <div class="col-lg-3 col-xl-2 mb-3">
                <div class="input-material">
                  <input
                    class="text-right"
                    v-model="item.multiple_points"
                    v-validate="'required'"
                    placeholder="."
                    type="number"
                    name="multiplepointsrquired"
                    id="multiplepointsrquired"
                  />
                  <label :for="'multiplepointsrquired'">
                    {{ $t("multiplepoints") }}</label
                  >
                </div>
                <p
                  v-if="submitted && errors.has('multiplepointsrquired')"
                  class="error_message"
                >
                  <span>{{ errors.first("multiplepointsrquired") }}</span>
                </p>
              </div>

              <div class="col-lg-3 col-xl-2 mb-3">
                <div class="input-material">
                  <input
                    class="text-right"
                    v-model="item.bonus_points"
                    v-validate="'required|numeric'"
                    placeholder="."
                    type="number"
                    name="bonuspoint"
                    id="bonuspoint"
                  />
                  <label :for="'bonuspoint'"> {{ $t("bonuspoints") }}</label>
                </div>
                <p
                  v-if="submitted && errors.has('bonuspoint')"
                  class="error_message"
                >
                  <span>{{ errors.first("bonuspoint") }}</span>
                </p>
              </div>

              <!-- <div class="col-lg-6 col-xl-4 mb-3">
                <div class="row mx-0 align-items-center">
                  {{ $t("pointsrequired") }} :
                  <div class="input-material-sm mx-2">
                    <input
                      class="text-right"
                      v-model="item.points_required"
                      v-validate="'required|numeric'"
                      placeholder="."
                      type="number"
                      name="pointrquired"
                      id="pointrquired"
                    />
                  </div>
                </div>
                <p
                  v-if="submitted && errors.has('pointrquired')"
                  class="error_message"
                >
                  <span>{{ errors.first("pointrquired") }}</span>
                </p>
              </div> -->

              <!-- <div class="col-lg-6 col-xl-4 mb-3">
                <div class="row mx-0 align-items-center">
                  {{ $t("multiplepoints") }} :
                  <div class="input-material-sm mx-2">
                    <input
                      class="text-right"
                      v-model="item.multiple_points"
                      v-validate="'required'"
                      placeholder="."
                      type="number"
                      name="multiplepointsrquired"
                      id="multiplepointsrquired"
                    />
                  </div>
                </div>
                <p
                  v-if="submitted && errors.has('multiplepointsrquired')"
                  class="error_message"
                >
                  <span>{{ errors.first("multiplepointsrquired") }}</span>
                </p>
              </div> -->

              <!-- <div class="col-lg-6 col-xl-4 mb-3">
                <div class="row mx-0 align-items-center">
                  {{ $t("bonuspoints") }} :
                  <div class="input-material-sm mx-2">
                    <input
                      class="text-right"
                      v-model="item.bonus_points"
                      v-validate="'required|numeric'"
                      placeholder="."
                      type="number"
                      name="bonuspoint"
                      id="bonuspoint"
                    />
                  </div>
                </div>
                <p
                  v-if="submitted && errors.has('bonuspoint')"
                  class="error_message"
                >
                  <span>{{ errors.first("bonuspoint") }}</span>
                </p>
              </div> -->

              <div class="col-md-3 col-xl-2 d-flex mb-3 pt-2">
                <b-form-checkbox
                  v-model="item.ll_is_active"
                  name="check-button"
                  class="j-checkbox pb-0"
                ></b-form-checkbox>
                <label class="mb-0">{{ $t("active") }}</label>
              </div>
            </div>
            <div class="col-1 align-self-center px-0">
              <div class="d-flex justify-content-start">
                <button
                  v-if="index == 0"
                  @click.prevent.stop="addLoyaltySettings()"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="40"
                    width="40"
                  />
                </button>

                <button
                  v-else
                  @click.prevent.stop="removeLoyaltySettings(index)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="40"
                    width="40"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div class="col-md-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="global-loyalty-settings"
            >{{ $t("cancel") }}
          </b-button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      ls_id: null,
      ls_name: "",
      expiry_rule: "",
      expiry_value: "",
      expiry_type: 3,
      lnitial_load: "",
      ls_is_active: true,
      visit_based_levels: "N",
      loyalty_levels: [],
      globalsettingsBYID: [],
      levels: ["Day", "Month", "Year", "Till Year End"],
      selectedExpiry: {
        expiry_id: 3,
        expiry_name: "Year",
        show_input: true,
      },
      expiryArray: [
        {
          expiry_id: 1,
          expiry_name: "Day",
          show_input: true,
        },
        {
          expiry_id: 2,
          expiry_name: "Month",
          show_input: true,
        },
        {
          expiry_id: 3,
          expiry_name: "Year",
          show_input: true,
        },
        {
          expiry_id: 4,
          expiry_name: "Year End",
          show_input: false,
        },
        {
          expiry_id: 5,
          expiry_name: "No Expiry",
          show_input: false,
        },
      ],
      removedGlobalLoyaltySettingsLevel: [],
    };
  },
  beforeMount() {
    const { ls_id } = this.$route.query;
    this.getGloballoyaltysettingsBYID(ls_id);
  },
  methods: {
    onChangeVistBasedLevels(event) {
      console.log("onChangeVistBasedLevels", event);
      this.loyalty_levels.map((x) => {
        x["points_required"] = null;
        x["visits"] = null;
        x["visit_within_days"] = null;
        x["visit_based_levels"] = event;
      });
      this.$forceUpdate();
    },
    getGloballoyaltysettingsBYID: function (id) {
      let payload = {
        ls_id: id,
      };
      MarketingService.GetGlobalLoyaltySettingsBYID(payload).then(
        (response) => {
          const { data } = response;

          if (data.status) {
            let objls = data.loyalty_settings;

            this.ls_id = objls.ls_id;
            this.ls_name = objls.ls_name;
            this.expiry_rule = objls.expiry_rule;
            this.expiry_value = objls.expiry_value;
            this.expiry_type = objls.expiry_type;
            this.selectedExpiry = {
              expiry_id: objls.expiry_type,
              expiry_name: objls.expiry_rule
            }
            this.lnitial_load = objls.lnitial_load;
            this.visit_based_levels = objls.visit_based_levels || "N";
            this.ls_is_active = objls.ls_is_active == "Y" ? true : false;

            this.loyalty_levels = data.loyalty_levels;
          }
        }
      );
    },
    onSelectLevel(params) {
      if (!params["show_input"]) {
        this.expiry_value = "";
      }
      this.selectedExpiry = params;
      this.expiry_rule = params["expiry_name"];
      this.expiry_type = params["expiry_id"];
    },
    addLoyaltySettings: function () {
      this.loyalty_levels.push({
        ll_name: "",
        visits: null,
        visit_within_days: null,
        points_required: null,
        multiple_points: null,
        bonus_points: null,
        ll_is_active: "Y",
      });
    },
    removeLoyaltySettings: function (index) {
      this.removedGlobalLoyaltySettingsLevel.push(this.loyalty_levels[index]);
      this.loyalty_levels.splice(index, 1);
    },
    validatePayload() {
      let errorMsg = ``;
      let errorCount = 0;

      if (!this.expiry_type) {
        errorCount++;
        errorMsg = `Please Select Expiry Rule`;
      } else if (!this.expiry_value && this.selectedExpiry["show_input"]) {
        errorCount++;
        errorMsg = `Please Enter Expiry Value`;
      }

      this.loyalty_levels.forEach((x) => {
        if (this.visit_based_levels == "Y") {
          if (isNaN(String(x["visits"]))) {
            errorCount++;
            errorMsg = `Please Enter Visits`;
          } else if (isNaN(String(x["visit_within_days"]))) {
            errorCount++;
            errorMsg = `Please Enter Days For Visits`;
          } else if (x["visit_based_levels"] == "N") {
            x["visit_based_levels"] = "Y";
          }
        } else if (this.visit_based_levels == "N") {
          if (isNaN(String(x["points_required"]))) {
            errorCount++;
            errorMsg = `Please Enter Points Required.`;
          }
        }
      });

      if (errorCount > 0) {
        this.$toasted.show(errorMsg);
        return false;
      } else {
        return true;
      }
    },
    OnFinalSubmit: function () {
      this.submitted = true;
      let validationCheck = this.validatePayload();
      this.$validator.validate().then((valid) => {
        if (this.expiry_rule.length == 0) {
          return;
        }
        if (valid && validationCheck) {
          let loader = this.$loading.show();

          let payload = {
            ls_id: this.ls_id,
            ls_name: this.ls_name,
            expiry_rule: this.expiry_rule,
            expiry_value: this.expiry_value,
            expiry_type: this.selectedExpiry["expiry_id"] || this.expiry_type,
            visit_based_levels: this.visit_based_levels || "N",
            lnitial_load: this.lnitial_load,
            ls_is_active: this.ls_is_active,
            loyalty_levels: this.loyalty_levels,
            removedGlobalLoyaltySettingsLevel:
              this.removedGlobalLoyaltySettingsLevel,
          };

          console.log("payload :>> ", payload);
          MarketingService.UpdateGlobalLoyaltySettingsBYID(payload)
            .then((response) => {
              this.btenable = false;

              const { data } = response;
              if (data.status) {
                this.submitted = false;
                this.$router.push({
                  path: "/marketing/global-loyalty-settings",
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
      // this.btenable = true;
    },
  },
};
</script>
<style>
.new-border {
  border: 2px solid #b1b4b8;
}
label {
  color: black !important;
}
.internal-border {
  border: 1px solid #3876d2;
  /*background-color: #e6e6f8;*/
  display: flex;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 0 15px 15px 15px;
  padding-top: 15px;
}
.back {
  background-color: #f5f5f5;
}
.back_white {
  background-color: white;
  border: 2px solid #b1b4b8;
  border-radius: 10px;
}
.levelText {
  line-height: 1;
  font-size: 18px;
  font-weight: bold;
  color: var(--blue);
  text-transform: capitalize;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/GlobalLoyaltySettingsComponents/editgloballoyaltysettings.vue